'use strict';

angular.module('app.notificationDiscoverCondition')
.directive('notificationDiscoverConditionDirective', function() {
    return {
        restrict: "EA",
        replace: true,
        scope: {
            conditionItem: "=",
            conditionIndex: "=",
            conditionListLength: "=",
            addCondition: "&",
            removeCondition: "&",
            conditionListObject: "=",
            reload: "=",
            countAddedCondition: '=',
            updateReload: '&',
            editRow: '=',
            addNewCondition: '=',
            enableWatch: '='
        },
        controller: 'notificationDiscoverConditionCtrl',
        templateUrl: 'app/notification/notificationDiscoverCondition/notificationDiscoverCondition.html?app_v=deployDate',
        link: function(scope, element, attrs) {
            scope.element = element;
            scope.initTagit();
        }
    }
})
